var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72871 5.96122L11.5963 2.10359C12.1099 1.59139 12.1219 0.838066 11.6361 0.358621C11.1528 -0.11842 10.4409 -0.136625 9.89565 0.407192L6.0278 4.265L2.13074 0.378053C1.7152 -0.0364327 0.902683 -0.181763 0.360938 0.358583C-0.180808 0.898929 -0.0710422 1.60959 0.42845 2.1078L4.31704 5.98629C4.31704 5.98629 0.894187 9.38557 0.408625 9.86749C-0.0769364 10.3494 -0.173914 11.0738 0.359528 11.606C0.892979 12.1382 1.68591 12.0021 2.11733 11.5718L6.01736 7.68183L10.0625 11.7165C10.4612 12.1143 11.1296 12.1084 11.6356 11.6037C12.0695 11.1709 12.127 10.3999 11.7482 10.0351L7.72871 5.96122Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXThin);
export default __webpack_public_path__ + "static/media/x-thin.a40a06baf54037d2b9f8296d87d8b036.svg";
export { ForwardRef as ReactComponent };